export default __webpack_public_path__ + "static/media/Hero 1.5830e155.webp";